import React, { useState, useEffect } from 'react';
import {
  Box, Grid, TextField, FormControl,
  FormHelperText, Button
} from '@mui/material';
import 'dayjs/locale/ko';
import UploadComponent from '../../common/form/UploadComponent';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; 
import DateAdapter from '@mui/lab/AdapterDateFns';
import * as dayjs from 'dayjs'

const RecordLicenseForm = ({ formik }) => {
  const [attrVal3, setAttrVal3] = useState(null);

  useEffect(() => {
    if (formik.values?.attrVal3 === '' || formik.values?.attrVal3 === null) {
      setAttrVal3(null);
    }
  }, [formik.values?.attrVal3])


  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  return (
    <div>
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          marginBottom: 2,
          px: 1,
        }}
        noValidate
        autoComplete="off"
        onSubmit={formik.handleSubmit}
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs>
            <TextField
              required
              margin="normal"
              variant="outlined"
              fullWidth
              id="attrVal1"
              name="attrVal1"
              label="자격증"
              value={formik.values.attrVal1}
              onChange={formik.handleChange}
              error={formik.touched.attrVal1 && Boolean(formik.errors.attrVal1)}
              helperText={formik.touched.attrVal1 && formik.errors.attrVal1}
            />
          </Grid>
          <Grid item xs>
            <TextField
              required
              margin="normal"
              variant="outlined"
              fullWidth
              id="attrVal2"
              name="attrVal2"
              label="발급처"
              value={formik.values.attrVal2}
              onChange={formik.handleChange}
              error={formik.touched.attrVal2 && Boolean(formik.errors.attrVal2)}
              helperText={formik.touched.attrVal2 && formik.errors.attrVal2}
            />
          </Grid>
          <Grid item xs>

            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
              <DatePicker
                label="발급일"
                format="YYYY-MM-DD"
                mask={'____-__-__'}
                id="attrVal3"
                name="attrVal3"
                value={dayjs(attrVal3)}
                onChange={(newValue) => {
                  setAttrVal3(dayjs(newValue));
                  onChangeDate(dayjs(newValue), 'attrVal3');
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    variant="outlined"
                    required
                    fullWidth
                    error={
                      formik.touched.attrVal3 &&
                      Boolean(formik.errors.attrVal3)
                    }
                    helperText={
                      formik.touched.attrVal3 && formik.errors.attrVal3
                    }
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs>
            <TextField
              required
              margin="normal"
              variant="outlined"
              fullWidth
              id="attrVal4"
              name="attrVal4"
              label="자격증번호"
              value={formik.values.attrVal4}
              onChange={formik.handleChange}
              error={formik.touched.attrVal4 && Boolean(formik.errors.attrVal4)}
              helperText={formik.touched.attrVal4 && formik.errors.attrVal4}
            />
          </Grid>
          <Grid item xs={4}>
            <UploadComponent formik={formik} />
            {formik.touched.file && Boolean(formik.errors.file) && (
              <FormControl error>
                <FormHelperText>
                  {formik.touched.file && formik.errors.file}
                </FormHelperText>
              </FormControl>
            )}
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item xs={11}>
            <TextField
              margin="normal"
              variant="outlined"
              fullWidth
              id="attrVal5"
              name="attrVal5"
              label="기타사항"
              value={formik.values.attrVal5}
              onChange={formik.handleChange}
              error={formik.touched.attrVal5 && Boolean(formik.errors.attrVal5)}
              helperText={formik.touched.attrVal5 && formik.errors.attrVal5}
            />
          </Grid>
          <Grid item xs={1}>
            <Box sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center'
            }}>
              <Button
                color="primary"
                variant="outlined"
                type="submit"
                disabled={formik.isSubmitting}
              >
                저장
              </Button>
            </Box>
          </Grid>
        </Grid>

      </Box>
    </div>
  );
};

export default RecordLicenseForm;
